import BaseStyle from 'primevue/base/style';

var classes = {
  root: 'p-ink'
};
var RippleStyle = BaseStyle.extend({
  name: 'ripple',
  classes: classes
});

export { RippleStyle as default };
